// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__PBFZp","col":"Table_col__1jplD","fulfillmentStatus":"Table_fulfillmentStatus__1tHVK","emailCol":"Table_emailCol__1mAdk"};